export const routesWithoutMobileHeader = [];
